/* eslint-env browser */
/* globals FB */
'use strict';

import Domodule from 'domodule';
import { addClass, hasClass, removeClass, find, on, fire } from 'domassist';
import tinybounce from 'tinybounce';
import isTouch from '../../_modules/feature-detect/touch';
import './tracking';

class CardsExpander extends Domodule {
  expand() {
    addClass(this.el, 'expanded');
    addClass(this.els.more, 'hide');
  }
}

class PartnerCard extends Domodule {
  postInit() {
    this.hover = false;
    this.calcBounds();

    if (!isTouch()) {
      this.el.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.el.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    } else {
      on(this.el, 'click', () => {
        this.el.focus();
      });
    }

    on(this.el, 'focus', this.onMouseEnter.bind(this));
    on(this.el, 'blur', this.onMouseLeave.bind(this));

    on(window, 'resize', tinybounce(this.onResize.bind(this), 150));
  }

  onResize(event) {
    const force = event.detail && event.detail.force;

    // Avoid resizing on mobile devices on scroll
    if (this.wWidth === window.innerWidth && !force) {
      return;
    }

    // Removing all styles and resetting the board
    this.els.overlay.removeAttribute('style');
    this.els.description.removeAttribute('style');
    this.els.body.removeAttribute('style');
    removeClass(this.el, 'ready');
    this.calcBounds();
  }

  calcBounds() {
    // Absolute position makes for different heights sometimes
    this.els.overlay.style.position = 'relative';
    this.overlayHeight = this.els.overlay.offsetHeight;

    if (this.overlayHeight === 0) { // This is actually not possible
      // This number may seem random but Safari 10.0.3 doesn't repaint for some reason.
      setTimeout(this.calcBounds.bind(this), 300);
      return;
    }

    // Caching the inner width of the window
    this.wWidth = window.innerWidth;

    // Height with an effective height of 0
    this.descriptionHeight = this.els.description.offsetHeight;
    this.els.description.style.marginBottom = `-${this.descriptionHeight}px`;

    this.bodyPadding = parseInt(window.getComputedStyle(this.els.body, null)
      .getPropertyValue('padding-bottom').replace('px', ''), 10);

    // Making overlay at least as tall as the description
    if (this.overlayHeight < this.descriptionHeight) {
      this.overlayHeight = this.descriptionHeight;
      this.els.overlay.style.height = `${this.descriptionHeight}px`;
    }

    // Min height on the body so it doesn't shrink itself during the animation
    // and always appears to be growing
    this.els.body.style.minHeight =
      `${this.descriptionHeight + this.bodyPadding}px`;
    addClass(this.el, 'ready');
  }

  onMouseEnter() {
    if (this.hover) {
      return;
    }

    this.hover = true;
    // Toggling the rest
    fire(find('.PartnerCard.hover'), 'blur');
    // Triggers box shadow and z-index
    addClass(this.el, 'hover');

    setTimeout(() => {
      // If we're not there when this runs
      if (this.hover) {
        const difference = (this.overlayHeight - this.els.body.offsetHeight)
          + this.bodyPadding + 1;

        this.els.overlay.style.maxHeight = `${this.overlayHeight}px`;

        if (difference > 0) {
          this.el.style.marginBottom = `-${difference}px`;
        }
      }
    }, 350);
  }

  onMouseLeave(event) {
    if ((event.type === 'blur' && this.el.contains(event.relatedTarget)) ||
      !this.hover) {
      return;
    }

    this.hover = false;
    this.els.overlay.style.maxHeight = 0;
    this.el.removeAttribute('style');

    setTimeout(() => {
      // If we're there again when this runs
      if (!this.hover) {
        removeClass(this.el, 'hover');
      }
    }, 350);
  }
}

class FBGroupCard extends Domodule {
  postInit() {
    if (this.els.group) {
      this.width = this.el.offsetWidth;

      if (hasClass(this.el, 'visible')) {
        this.onElementVisible();
      } else {
        on(this.el, 'scrolltriggers:inView', this.onElementVisible.bind(this));
      }
    }
  }

  onElementVisible() {
    if (window.FB) {
      this.render();
    } else {
      const f = window.fbAsyncInit;

      window.fbAsyncInit = () => {
        f();
        this.render();
      };
    }

    on(window, 'resize', tinybounce(this.onResize.bind(this), 150));
  }

  onResize() {
    const width = this.el.offsetWidth;

    if (width !== this.width) {
      this.width = width;
      this.render();
    }
  }

  render() {
    removeClass(this.els.footer, 'fb-render');
    this.els.group.innerHTML = `<div class="fb-group" data-width="${this.width}" data-href="${this.options.href}" data-adapt-container-width="${this.options.responsive === 'true'}"></div>`;

    FB.XFBML.parse(this.els.group, () => {
      setTimeout(() => {
        addClass(this.els.footer, 'fb-render');
      }, 150);
    });
  }
}

Domodule.register('CardsExpander', CardsExpander);
Domodule.register('PartnerCard', PartnerCard);
Domodule.register('FBGroupCard', FBGroupCard);
